<div class="flex-row flex-g-s pd-l-m">
  <button (click)="switchMode(FeatureComponentMode.DATA)" [disabled]="isDataMode()" class="secondary-button">
    <i class="fa-sharp fa-light fa-database"></i>
    <span>{{ label.data }}</span>
  </button>
  <button (click)="switchMode(FeatureComponentMode.CHART)" [disabled]="!isDataMode()" class="secondary-button">
    <i class="fa-sharp fa-light fa-chart-line"></i>
    <span>{{ label.visual }}</span>
  </button>
</div>
